var _defs, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _g2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-31,.cls-5,.cls-6,.cls-7,.cls-8{fill:#fff;}.cls-32,.cls-4{stroke:#002549;stroke-miterlimit:10;}.cls-4{stroke-width:0.19px;}.cls-26,.cls-5{font-size:20.29px;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{font-family:CeraPro-Medium, Cera Pro;font-weight:500;}.cls-6{font-size:20.29px;}.cls-13,.cls-7{font-size:30.44px;}.cls-8{font-size:30.44px;}.cls-9{font-size:20.29px;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-32,.cls-9{fill:#002549;}.cls-10{font-size:25.36px;}.cls-11{font-size:30.44px;}.cls-12{font-size:30.44px;}.cls-14{font-size:30.44px;}.cls-15{font-size:30.44px;}.cls-16{font-size:30.44px;}.cls-17{font-size:30.44px;}.cls-18{font-size:30.44px;}.cls-19{font-size:30.44px;}.cls-20{font-size:25.36px;}.cls-21{font-size:25.36px;}.cls-22{font-size:20.29px;}.cls-23{font-size:20.29px;}.cls-24{font-size:22.83px;}.cls-25{font-size:25.36px;}.cls-26{font-family:CeraPro-Light, Cera Pro;font-weight:300;}.cls-27{font-size:30.44px;}.cls-28,.cls-31{font-size:30.44px;}.cls-29{font-size:25.36px;}.cls-30{font-size:25.36px;}.cls-32{stroke-width:0.46px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 636.44,
    y: 88.09,
    width: 630.39,
    height: 967.01
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M951.63,88.09h0c-174.07,0-315.19,133.82-315.19,323.4V736.58c0,184,138.26,315.28,309.87,317.95-131-3.47-236.38-134.46-236.38-317.92V411.52c0-189.57,108.22-323.39,241.7-323.39s241.7,133.82,241.7,323.39V736.61c0,183.46-105.35,314.45-236.37,317.92,171.61-2.67,309.87-133.91,309.87-317.95V411.49c0-189.58-141.12-323.4-315.2-323.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M872,1041.67s48.5,22.75,134.19,8.47"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "matrix(0.38, 0.93, -0.93, 0.38, 1198.03, 280.81)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(0.34, 0.94, -0.94, 0.34, 1202.05, 290.94)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 467.73) rotate(90)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 509.09) rotate(90)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 525.59) rotate(90)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 541.96) rotate(90)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 558.43) rotate(90)"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 574.92) rotate(90)"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 591.42) rotate(90)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 607.79) rotate(90)"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 624.23) rotate(90)"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 640.73) rotate(90)"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 657.13) rotate(90)"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1217.87 640.73) rotate(90)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(1199.1 843.9) rotate(106.34)"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(685.39 572.84) rotate(-90)"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(685.4 554.06) rotate(-90)"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(685.39 492.45) rotate(-90)"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(685.4 473.58) rotate(-90)"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(1205.73 300.99) rotate(72.75)"
  }, "2")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(1210.57 317) rotate(76.83)"
  }, "5")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "matrix(0.15, 0.99, -0.99, 0.15, 1214.82, 337)"
  }, ".")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(1217.18 353.08) rotate(87.1)"
  }, "2")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(1217.87 378.12) rotate(90)"
  }, "7")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(1217.87 399.95) rotate(90)"
  }, "4")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(1217.87 425.58) rotate(90)"
  }, "4")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(1217.87 448.83) rotate(90)"
  }, "\xB0")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(1217.87 484.13) rotate(90)"
  }, "S")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(1217.87 657.22) rotate(90)"
  }, "1")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "matrix(-0.02, 1, -1, -0.02, 1217.96, 676.87)"
  }, "3")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1217.39 701.32) rotate(92.5)"
  }, "3")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(1216.18 725.59) rotate(93.7)"
  }, ".")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(1215.13 741.67) rotate(94.93)"
  }, "7")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(1213 764.94) rotate(96.62)"
  }, "7")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(1210.2 788.18) rotate(98.75)"
  }, "5")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(1206.21 812.62) rotate(101.15)"
  }, "1")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "cls-21",
    transform: "translate(1202.94 828.6) rotate(103.46)"
  }, "\xB0")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(1194.46 859.24) rotate(110.9)"
  }, "E")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(695.57 846.99) rotate(-107.07)"
  }, "I")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "cls-24",
    transform: "translate(692.11 835.49) rotate(-102.95)"
  }, "N")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "cls-25",
    transform: "translate(687.26 812.45) rotate(-96.45)"
  }, "S")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(685.39 790.36) rotate(-90)"
  }, "P")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(685.4 762.27) rotate(-90)"
  }, "I")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(685.4 743.55) rotate(-90)"
  }, "R")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(685.4 714.06) rotate(-90)"
  }, "A")), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(685.4 685.82) rotate(-90)"
  }, "T")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(685.4 657.66) rotate(-90)"
  }, "I")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(685.4 639.1) rotate(-90)"
  }, "O")), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(685.4 604.92) rotate(-90)"
  }, "N")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(685.4 535.04) rotate(-90)"
  }, "O")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(685.4 511.13) rotate(-90)"
  }, "F")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "matrix(0.03, -1, 1, 0.03, 685.33, 454.93)"
  }, "B")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "matrix(0.07, -1, 1, 0.07, 686.44, 425.89)"
  }, "E")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "cls-27",
    transform: "matrix(0.1, -0.99, 0.99, 0.1, 688.4, 398.48)"
  }, "A")), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "cls-28",
    transform: "matrix(0.14, -0.99, 0.99, 0.14, 691.6, 369.12)"
  }, "U")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "cls-29",
    transform: "translate(696.21 338.27) rotate(-79.22)"
  }, "T")), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "cls-30",
    transform: "matrix(0.23, -0.97, 0.97, 0.23, 700.74, 315.42)"
  }, "Y")), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "cls-31",
    transform: "translate(706.64 292.13) rotate(-73.37)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 782.16,
    y: 528.41,
    width: 343.08,
    height: 5.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 954.83,
    y: 436.25,
    width: 2.24,
    height: 26.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "735.14 554.55 733.31 551.14 955.98 431.84 1171.88 551.15 1170 554.54 955.94 436.25 735.14 554.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M734.83,555.57l-2.54-4.74L956,431l.36.19,216.55,119.67-2.6,4.71-.65-.37L955.94,437.11Zm-.51-4.13,1.12,2.1L956,435.4l.36.2,213.4,117.92,1.15-2.08L956,432.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 922.3,
    y: 452.9,
    width: 2.24,
    height: 76.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 987.29,
    y: 454.11,
    width: 2.24,
    height: 75.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M923.43,504.74h65V463.69h-65Zm5-35.82H953v30.55H928.45Zm55.2,30.55H958.76V468.92h24.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 954.86,
    y: 504.73,
    width: 2.24,
    height: 24.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 824.45,
    y: 503.59,
    width: 259.24,
    height: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 900.09,
    y: 462.56,
    width: 108.96,
    height: 2.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 892.99,
    y: 466.17,
    width: 2.24,
    height: 63.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1016.14,
    y: 467.75,
    width: 2.24,
    height: 61.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 863.39,
    y: 482.34,
    width: 2.24,
    height: 47.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1043.76,
    y: 483.34,
    width: 2.24,
    height: 46.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1072.62,
    y: 499.76,
    width: 2.24,
    height: 30.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 831.68,
    y: 499.76,
    width: 2.24,
    height: 30.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.24,
    y: 563.89,
    width: 340.86,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.24,
    y: 585.89,
    width: 340.86,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 782.12,
    y: 529.46,
    width: 2.24,
    height: 110.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1122.97,
    y: 529.98,
    width: 2.24,
    height: 107.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1124.09 541.64 1147.74 541.64 1154.47 545.37 1124.09 545.37 1124.09 541.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "783.24 541.64 756.85 541.64 749.74 545.37 783.24 545.37 783.24 541.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 801.19,
    y: 517.1,
    width: 2.24,
    height: 12.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1104.71,
    y: 517.55,
    width: 2.24,
    height: 12.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 839.48,
    y: 531.85,
    width: 2.24,
    height: 106.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 954.86,
    y: 532.67,
    width: 2.24,
    height: 107.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1067.16,
    y: 532.67,
    width: 2.24,
    height: 107.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 896.07,
    y: 531.9,
    width: 2.24,
    height: 107.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1011.5,
    y: 532.67,
    width: 2.24,
    height: 107.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 708.79,
    y: 637.86,
    width: 485.33,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 709.16,
    y: 663.46,
    width: 484.95,
    height: 3.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1194.86,667.94H708.41v-5.23h486.45Zm-445.43-1.5h443.94v-2.23H749.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 576.01,
    width: 340.86,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 753.8,
    y: 639.73,
    width: 1.5,
    height: 25.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 810.97,
    y: 587.75,
    width: 1.5,
    height: 77.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 867.79,
    y: 639.73,
    width: 1.5,
    height: 25.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 924.97,
    y: 639.73,
    width: 1.5,
    height: 25.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 982.97,
    y: 640.57,
    width: 1.5,
    height: 25.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1040.14,
    y: 640.57,
    width: 1.5,
    height: 25.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1096.09,
    y: 587.76,
    width: 1.5,
    height: 77.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1150.86,
    y: 640.57,
    width: 1.5,
    height: 25.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 708.79,
    y: 651.78,
    width: 484.19,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 815.36,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 826.42,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 815.36,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 826.42,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 788.31,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 799.37,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 788.31,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 799.37,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 876.13,
    y: 512.59,
    width: 1.77,
    height: 10.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M878.27,523.84h-2.52V512.21h2.52Zm-1.77-.75h1V513h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M909,523.73a8.63,8.63,0,0,1-2.27-.31A7.73,7.73,0,0,1,904,522.1l.88-1.57a7,7,0,0,0,4,1.35c2.27,0,4.73-1.26,5-3.75a9.74,9.74,0,0,1-5.12,1.24,9,9,0,0,1-2-.22c-1.56-.38-3.25-1.38-3.25-3.18s1.75-2.92,3.29-3.34a8.84,8.84,0,0,1,2.34-.3c3.34,0,6.59,1.9,6.59,5.57s-3.4,5.83-6.73,5.83m.13-9.58a6.47,6.47,0,0,0-1.53.17c-.73.16-2.32.71-2.32,1.61s1.3,1.31,2,1.47a6.38,6.38,0,0,0,1.5.16,10.68,10.68,0,0,0,4.75-1.23,4.57,4.57,0,0,0-4.35-2.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M909,524.11a9,9,0,0,1-2.37-.33,8,8,0,0,1-2.83-1.37l-.28-.19,1.25-2.22.32.22a6.78,6.78,0,0,0,3.84,1.29c1.9,0,3.9-.93,4.44-2.73a9.51,9.51,0,0,1-4.61,1,9.9,9.9,0,0,1-2.08-.22c-2.22-.55-3.54-1.87-3.54-3.55,0-2,1.91-3.25,3.56-3.7a8.9,8.9,0,0,1,2.44-.31c3.46,0,7,2,7,5.94s-3.61,6.21-7.1,6.21M904.47,522a7.29,7.29,0,0,0,2.32,1.07,8.22,8.22,0,0,0,2.17.3c3.12,0,6.35-2,6.35-5.46s-3.21-5.19-6.21-5.19a8.28,8.28,0,0,0-2.24.28c-1.4.38-3,1.39-3,3,0,1.94,2.28,2.65,3,2.82a9,9,0,0,0,1.91.2,9.4,9.4,0,0,0,4.95-1.19l.6-.29-.06.66c-.23,2.68-2.85,4.09-5.32,4.09a7.13,7.13,0,0,1-3.9-1.2Zm4.22-4a7.29,7.29,0,0,1-1.58-.17c-.54-.14-2.25-.67-2.25-1.83,0-1.31,2.17-1.89,2.61-2a7.53,7.53,0,0,1,1.62-.17c2.24,0,3.86.82,4.68,2.38l.18.34-.35.17a11.26,11.26,0,0,1-4.91,1.27m.4-3.41a6.59,6.59,0,0,0-1.45.15c-1,.24-2,.76-2,1.26s.84.89,1.67,1.1a6.35,6.35,0,0,0,1.41.15,10,10,0,0,0,4.21-1,4.41,4.41,0,0,0-3.81-1.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M997.25,523.47a3.78,3.78,0,0,1,0-.67c0-2.69,1.43-5.21,4.25-5.63.85-.13,1.72-.18,2.57-.34.68-.11,1.4-.49,1.4-1.28,0-1.15-2-1.42-2.88-1.42a8,8,0,0,0-4.23,1.14l-.76-1.59a8.54,8.54,0,0,1,5-1.33c1.88,0,4.67.82,4.67,3.12,0,1.88-1.72,3-3.42,3.25a17.17,17.17,0,0,0-2.69.42c-.91.28-1.53.89-1.93,2.53h8.05v1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1007.61,523.84H996.93l0-.31a6,6,0,0,1-.06-.73c0-2.65,1.42-5.53,4.57-6,.39-.06.79-.11,1.18-.15s.92-.11,1.38-.19,1.09-.25,1.09-.91-1.72-1-2.5-1a7.57,7.57,0,0,0-4,1.09l-.34.17-1.09-2.24.31-.17a8.86,8.86,0,0,1,5.18-1.39c2,0,5,.94,5,3.5,0,2.12-1.88,3.34-3.74,3.62l-.93.11a8.8,8.8,0,0,0-1.69.29c-.66.2-1.17.6-1.56,1.8h7.94Zm-10-.75h9.28V522H998.7l.12-.46c.4-1.64,1-2.45,2.18-2.8a9.89,9.89,0,0,1,1.83-.32l.92-.11c1.54-.23,3.09-1.21,3.09-2.88,0-2-2.56-2.74-4.29-2.74a7.93,7.93,0,0,0-4.51,1.11l.45.92a8,8,0,0,1,4-1c1.12,0,3.25.37,3.25,1.79,0,.84-.66,1.47-1.71,1.66-.47.07-1,.13-1.43.18l-1.14.15c-2.72.4-3.93,2.93-3.93,5.26v.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1034.92,523a7.18,7.18,0,0,1-3.67.81,7,7,0,0,1-3.25-.63,5.73,5.73,0,0,1-3.12-5,6.15,6.15,0,0,1,.32-1.89c.89-2.73,3.42-3.9,6.14-3.9a7.22,7.22,0,0,1,3.64.86,5.67,5.67,0,0,1-.06,9.78m-3.57-8.89c-2.41,0-4.65,1.42-4.65,4s2.3,4,4.64,4,4.59-1.45,4.59-4.07-2.22-3.92-4.58-3.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1031.25,524.16a7.46,7.46,0,0,1-3.42-.67,6.15,6.15,0,0,1-3.32-5.37,6.41,6.41,0,0,1,.34-2c.84-2.61,3.26-4.16,6.49-4.16a7.59,7.59,0,0,1,3.83.9,6,6,0,0,1-.07,10.43,7.42,7.42,0,0,1-3.85.87m.09-11.45c-2.93,0-5,1.33-5.78,3.64a5.53,5.53,0,0,0-.3,1.77,5.37,5.37,0,0,0,2.91,4.7,8.34,8.34,0,0,0,6.56-.17,5.3,5.3,0,0,0,.07-9.14,6.92,6.92,0,0,0-3.46-.8m0,9.73c-2.49,0-5-1.48-5-4.32s2.52-4.41,5-4.41,5,1.34,5,4.29c0,2.62-2,4.44-5,4.44m0-8c-2.06,0-4.28,1.14-4.28,3.66,0,2.34,2.15,3.57,4.27,3.57s4.22-1.15,4.22-3.69-2.18-3.54-4.21-3.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 594.05,
    width: 57.03,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 599.52,
    width: 57.03,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 604.75,
    width: 57.03,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 610.22,
    width: 57.03,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 615.69,
    width: 57.03,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 621.17,
    width: 57.03,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 626.14,
    width: 57.03,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 783.57,
    y: 631.61,
    width: 57.03,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 871.97,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 883.04,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 871.97,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 883.04,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 844.92,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 855.98,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 844.92,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 855.98,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 930.03,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 941.09,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 930.03,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 941.09,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 902.98,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 914.04,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 902.98,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 914.04,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 987.7,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 998.76,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 987.7,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 998.76,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960.65,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 971.71,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960.65,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 971.71,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1043.59,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1054.65,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1043.59,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1054.65,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1016.53,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1027.6,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1016.53,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1027.6,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1099.72,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1110.78,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1099.72,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1110.78,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1072.66,
    y: 537.58,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1083.73,
    y: 537.58,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1072.66,
    y: 550.01,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1083.73,
    y: 550.01,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.28,
    y: 594.03,
    width: 55.81,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.28,
    y: 599.5,
    width: 55.81,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.28,
    y: 604.72,
    width: 55.81,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.28,
    y: 610.19,
    width: 55.81,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.28,
    y: 615.67,
    width: 55.81,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.28,
    y: 621.14,
    width: 55.81,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.28,
    y: 626.12,
    width: 55.81,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.28,
    y: 631.59,
    width: 55.81,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1125.55,814.12H781v-148h344.51Zm-342.27-2.24h340V668.31h-340Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 814.88,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 825.94,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 814.88,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 825.94,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 785.34,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 796.4,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 785.34,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 796.4,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 871.5,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 882.55,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 871.5,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 882.55,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 844.44,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 855.5,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 844.44,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 855.5,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 930.45,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 941.5,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 930.45,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 941.5,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 900.86,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 911.92,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 900.86,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 911.92,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 987.22,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 998.28,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 987.22,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 998.28,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 959.21,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 970.26,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 959.21,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 970.26,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1043.11,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1054.17,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1043.11,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1054.17,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1016.06,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1027.12,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1016.06,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1027.12,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1101.09,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1112.16,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1101.09,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1112.16,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1073.15,
    y: 673.37,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1084.21,
    y: 673.37,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1073.15,
    y: 685.8,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1084.21,
    y: 685.8,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 814.63,
    y: 745.09,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 825.69,
    y: 745.09,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 814.63,
    y: 757.52,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 825.69,
    y: 757.52,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 785.09,
    y: 745.09,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 796.15,
    y: 745.09,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 785.09,
    y: 757.52,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 796.15,
    y: 757.52,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1101.12,
    y: 745.78,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1112.18,
    y: 745.78,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1101.12,
    y: 758.2,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1112.18,
    y: 758.2,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1073.17,
    y: 745.78,
    width: 9.13,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1084.23,
    y: 745.78,
    width: 9.27,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1073.17,
    y: 758.2,
    width: 9.13,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1084.23,
    y: 758.2,
    width: 9.27,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 840.03,
    y: 700.67,
    width: 230.29,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 840.03,
    y: 706.15,
    width: 230.29,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 840.03,
    y: 711.37,
    width: 230.29,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 840.03,
    y: 716.85,
    width: 230.29,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 840.03,
    y: 722.32,
    width: 230.29,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 840.03,
    y: 727.79,
    width: 230.29,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 840.03,
    y: 732.77,
    width: 230.29,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 840.03,
    y: 738.24,
    width: 230.29,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 839.48,
    y: 667.33,
    width: 2.24,
    height: 145.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 809.51,
    y: 666.29,
    width: 2.24,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1095.72,
    y: 666.97,
    width: 2.24,
    height: 145.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1068.53,
    y: 667.14,
    width: 2.24,
    height: 145.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1038.35,
    y: 664.23,
    width: 2.24,
    height: 148.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1010.68,
    y: 664.23,
    width: 2.24,
    height: 75.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 982.6,
    y: 663.86,
    width: 2.24,
    height: 75.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 953.9,
    y: 663.86,
    width: 2.24,
    height: 149.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 924.59,
    y: 664.59,
    width: 2.24,
    height: 148.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 895.21,
    y: 663.86,
    width: 2.24,
    height: 148.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 867.42,
    y: 664.59,
    width: 2.24,
    height: 148.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1191.48 810.4 709.64 811.89 709.64 815.63 1191.48 814.13 1191.48 810.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1192.23,814.88H710.38v-5.23h481.85Zm-481.85,0,480.35-1.5v-2.23l-480.35,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1104.68,377.08V351l-26.11-40.22H1091L1110,340.11l19-29.31h12.42L1115.27,351v26.06ZM834.25,355.91,835,354H823.49l-.4.73a23.39,23.39,0,0,1-20.48,11.9c-12.84,0-23.28-10.16-23.28-22.66s10.44-22.67,23.28-22.67a23.4,23.4,0,0,1,20.45,11.86l.4.73H835l-.78-1.94a34.17,34.17,0,0,0-31.61-21.12c-18.72,0-33.94,14.87-33.94,33.14s15.22,33.14,33.94,33.14a34.2,34.2,0,0,0,31.64-21.17m240.06-12c0-18.27-15.22-33.14-33.93-33.14s-33.94,14.87-33.94,33.14S1021.67,377,1040.38,377s33.93-14.86,33.93-33.14m-10.66,0c0,12.5-10.44,22.67-23.27,22.67s-23.27-10.17-23.27-22.67,10.44-22.66,23.27-22.66,23.27,10.16,23.27,22.66M906.94,321.37V310.8H855.29v27.84h-6.6V349.3h6.6v27.78h51.65V366.51h-40.8V349.28h36.78V338.62H866.14V321.37Zm84.43,55.69V310.78L958,342.11h0l-33.35-31.32v66.28h10.65V334.25l21.62,21.09,1.09,1.07h0l1-1,21.74-21.2v42.81Zm49.09-83.75-15.54,5.6v7.64l15.54-5.57,15.38,5.57v-7.64Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 1228.95,
    y1: 541.7,
    x2: 1228.95,
    y2: 629.53
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.d5fe7ef162a862d738e8a271f4f086bf.svg";
export { ForwardRef as ReactComponent };